export default async function ({ store, redirect }) {
  if (!store.getters["user/IS_BAND"]) return redirect("/")
}
